// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"47":"7584e625","735":"71ef25cb","936":"c3c6ec67"}[chunkId] + ".chunk.js";
};